import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { QUESTIONS_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { category_get_all_select, role_get_select } from "../../services/site/SelectBoxServices";
import { post } from "../../services/smartApiService";
import QuestionsSubForm from "./QuestionsSubform";

interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}
const schema = Yup.object({
  // add category_id
  category_id: Yup.object().required("Category is required"),
  question_english: Yup.string().required("Question (English) is required"),
  question_hindi: Yup.string().required("Question (Hindi) is required"),
  correct_option_id: Yup.object().required("Select Answer Option is required"),
  question_image: Yup.mixed()
  .notRequired() 
  .test(
    "fileType",
    "Only Images are Allowed",
    (value: any) =>
      !value || ["image/jpeg", "image/png", "image/gif"].includes(value.type) 
  )
  .test(
    "fileSize",
    "File size must be less than 500 KB",
    (value: any) => !value || value.size <= 500 * 1024 
  ),

  subData: Yup.array().of(
    Yup.object({
      sub_question: Yup.string().required("Sub Question is required"),
      sub_answer: Yup.string().required("Sub Answer is required"),
    })
  ),
});

const QuestionsForm: React.FC<HeaderProps> = ({ loadTableData, dataIn }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: dataIn,
    resolver: yupResolver(schema),
  });
  const { closeModal } = useSiteContext();

  const [allRole, setAllRole] = useState([]);
  const [allCategory, setAllCategory] = useState([]);
  useEffect(() => {
    role_get_select((data: any) => setAllRole(data));
    // category get_all_select
    category_get_all_select((data: any) => setAllCategory(data));
  }, []);

  const onSubmit = (data: any) => {
    let url = QUESTIONS_URLS.INSERT;
    if (dataIn.ID !== undefined) {
      data["id"] = dataIn.ID;
      url = QUESTIONS_URLS.UPDATE;
    }
    const subscription = post(url, data).subscribe((response) => {
      loadTableData();
      closeModal();
    });
    return () => {
      subscription.unsubscribe();
    };
  };
  const elements: SdsFormElementProps[] = [
    {
      type: "SELECT_BOX",
      width: 6,
      name: "category_id",
      element: {
        label: "Category",
        placeHolder: "Select",
        options:allCategory
      }
    },
    {
      type: "TEXT_BOX",
      width: 12,
      name: "question_english",
      element: {
        label: "Question (English)",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 12,
      name: "question_hindi",
      element: {
        label: "Question (Hindi)",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "LABEL",
      name: "label_date",
      width: 12,
      labelComponent: (
        <>
          <QuestionsSubForm
            errors={errors}
            control={control}
            watch={watch}
            setValue={setValue}
          />
        </>
      ),
    },
    {
      type: "SELECT_BOX",
      width: 6,
      name: "correct_option_id",
      element: {
        label: "Select Answer Option",
        placeHolder: "Select",
        isRequired: true,
        options: [
          { value: "1", label: "1" },
          { value: "2", label: "2" },
          { value: "3", label: "3" },
          { value: "4", label: "4" },
        ],
        // inputType: "BORDER_LABEL",
      },
    },
    {
      type: "FILE",
      width: 6,
      name: "question_image",
      element: {
        label: "Browser Question Images(If Any)",
        placeHolder: "(Image Only)",
        isRequired: true,
        accept: "image/*",
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "BUTTON",
      width: 12,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];
  return (
    <>
      <div className="sd-hims-input">
        <SdsForm elements={elements} errors={errors} control={control} />
      </div>
    </>
  );
};

export default QuestionsForm;
